import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Image, SimpleGrid, Box, useMultiStyleConfig} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import useDamImage from '../../../custom-hooks/use-dam-image'
import SanitizedHtml from '../../html-sanitizer'
import {remCalc} from '../../../theme/_utils'

const KeyFeaturesCardEditorial = ({
    imageUrl,
    images,
    title,
    description,
    linkLabel,
    linkUrl,
    isSlider,
    isLinkAbsolute = false,
    aspectRatio = null,
}) => {
    const styles = useMultiStyleConfig('KeyFeaturesEditorial', {
        variant: isSlider ? 'slider' : 'default',
    })

    const damImage = useDamImage(images)

    const imageToUse = damImage.url || imageUrl

    const buttonProps = isLinkAbsolute
        ? {
              as: 'a',
              href: linkUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: linkUrl,
          }
    return (
        <Flex {...styles.card}>
            <SimpleGrid {...styles.cardContent}>
                {imageToUse && (
                    <Image
                        width={!isSlider ? '100%' : 'inherit'}
                        height={!isSlider ? remCalc(230) : 'inherit'}
                        src={imageToUse}
                        aspectRatio={aspectRatio}
                        objectFit={'cover'}
                        alt=""
                        borderRadius={'12px'}
                    />
                )}
                <SanitizedHtml as={Box} html={title} {...styles.cardTitle} />
                <SanitizedHtml as={Box} html={description} {...styles.cardDescription} />
            </SimpleGrid>
            {linkUrl && linkLabel && (
                <Button {...buttonProps} variant="primary" {...styles.cardButton}>
                    {linkLabel}
                </Button>
            )}
        </Flex>
    )
}

KeyFeaturesCardEditorial.propTypes = {
    isLinkAbsolute: PropTypes.bool,
    imageUrl: PropTypes.string,
    images: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    isSlider: PropTypes.bool,
    aspectRatio: PropTypes.string,
}

export default KeyFeaturesCardEditorial
